import GraphQLCRUD from '@/se/components/GraphQLCRUD';
import scheme from '../../../graph/config';
import { listColumns, viewColumns } from './columns';
import { compose, withProps } from 'recompose';
import { withLabel } from '@/se/components/Label';
import TextInput from '@/se/components/inputs/TextInput';
import ObjectInput from '@/se/components/inputs/ObjectInput';
import { H2 } from '@/se/components/typography';
import React from 'react';
import { graphql } from '@apollo/client/react/hoc';
import { ConfigType } from '../../../types/HospitalConfig';

const Input = withProps({
  schema: {
    name: compose(
      withLabel('Name'),
      withProps({
        placeholder: 'e.g., BMI',
        autoComplete: 'off',
        required: true,
      })
    )(TextInput),
    path: compose(
      withLabel('Path'),
      withProps({
        placeholder: 'e.g., form/bmi',
        autoComplete: 'off',
        required: true,
      })
    )(TextInput),
    type: compose(
      withLabel('Field Type'),
      withProps({
        placeholder: 'e.g., BMI',
        autoComplete: 'off',
      })
    )(TextInput),
    min: compose(
      withLabel('Min'),
      withProps({
        placeholder: 'e.g., 20',
        autoComplete: 'off',
      })
    )(TextInput),
    max: compose(
      withLabel('Max'),
      withProps({
        placeholder: 'e.g., 28',
        autoComplete: 'off',
      })
    )(TextInput),
  },
})(ObjectInput);

const prepareCreateData = formData => ({
  type: ConfigType.PatientChartField,
  values: JSON.stringify(formData),
});

const prepareUpdateData = formData => ({
  id: formData?.id,
  values: JSON.stringify(formData),
});

export const mapEditItemProps = ({ data }) => {
  if (data) {
    const obj = {
      ...data,
      config: {
        ...data.config,
        ...JSON.parse(data.config.values || '{}'),
      },
    };
    return { data: obj };
  }
};

const Title = () => <H2>{'Patient Chart Fields Config'}</H2>;

const PatientChartFieldConfig = GraphQLCRUD({
  entityName: 'Config',
  scheme,
  List: {
    tableKey: 'Config',
    columns: listColumns,
    simpleFilter: true,
    Title,
    itemsProvider: graphql(scheme.list, {
      options: () => ({
        variables: {
          type: ConfigType.PatientChartField,
          fetchPolicy: 'cache-and-network',
        },
      }),
    }),
  },
  Create: {
    Input,
    prepareCreateData,
    refetchQueries: [{ query: scheme.list, variables: { type: ConfigType.PatientChartField } }],
  },
  Show: {
    columns: viewColumns,
  },
  Edit: {
    Input,
    mapEditItemProps,
    prepareUpdateData,
  },
});

export default PatientChartFieldConfig;
